'use client';

import { c as _c } from "react/compiler-runtime";
import { ApiErrors } from '@repo/features/error';
import Link from 'next/link';
import { getCompanyOverviewPath } from './helpers';
type ExistingCompanyAlertProps = {
  company: {
    id: number;
    title: string;
    type?: null | {
      alias?: 'broker' | 'haulier' | 'other' | 'shipper' | null;
    };
  };
};
export const ExistingCompanyAlert = t0 => {
  const $ = _c(6);
  const {
    company
  } = t0;
  const companyTypeAlias = company.type?.alias;
  let t1;
  if ($[0] !== company.id || $[1] !== companyTypeAlias) {
    t1 = companyTypeAlias === "broker" || companyTypeAlias === "haulier" || companyTypeAlias === "shipper" ? getCompanyOverviewPath({
      id: company.id,
      type: companyTypeAlias
    }) : null;
    $[0] = company.id;
    $[1] = companyTypeAlias;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const href = t1;
  let t2;
  if ($[3] !== company.title || $[4] !== href) {
    t2 = <ApiErrors errors={{
      message: <>This VAT number already belongs to{" "}{href ? <Link className="font-medium underline" href={href} target="_blank">{company.title}</Link> : <span className="font-medium">{company.title}</span>}. Open the existing company instead of creating a duplicate.</>,
      title: "Company already exists"
    }} data-sentry-element="ApiErrors" data-sentry-component="ExistingCompanyAlert" data-sentry-source-file="existing-company-alert.tsx" />;
    $[3] = company.title;
    $[4] = href;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};